import { default as Select } from 'antd/es/select';
import { default as Space } from 'antd/es/space';

import { filterOption } from 'utils/antd/filters-option';

import { LocalDateRangeWrapper } from '@molecules/LocalDateRangeWrapper';

import {
  PAYOUT_DRAFTS_STATUS_FILTER_TEST_ID,
  PAYOUT_DRAFTS_STATUSES
} from './constants';
import type { FiltersState } from './localState';

type Props = {
  filters: FiltersState;
  setFilters: (filtersState: FiltersState) => void;
  resetState: () => void;
};

export const PayoutDraftFilters = ({ filters, setFilters }: Props) => {
  return (
    <div className="flex items-center">
      <Space wrap size="small">
        <LocalDateRangeWrapper />

        {/* Status */}
        <Select
          data-testid={PAYOUT_DRAFTS_STATUS_FILTER_TEST_ID}
          className="w-40"
          showSearch
          value={filters.status}
          filterOption={filterOption}
          options={PAYOUT_DRAFTS_STATUSES}
          popupMatchSelectWidth={false}
          defaultValue="waiting_review"
          onChange={(value) => {
            setFilters({
              ...filters,
              status: value
            });
          }}
        />
      </Space>
    </div>
  );
};
